export default __webpack_public_path__ + "static/media/50.4c7b9137.jpg";